import React, { useEffect, useState } from 'react';
import { FormInputSelect } from '../../../../common/formInputsV2/FormInputSelect';
import {
  apartament_types, construction_feature_types, construction_year, flagResponse, houseTypes, housing_types, ownerTypes, residential_use_types,
} from '../../../../common/constants';
import { FormInputText } from '../../../../common/formInputsV2/FormInputText';
import { FormInputRadio } from '../../../../common/formInputsV2/FormInputRadio';
import { FormInputPrice } from '../../../../common/formInputsV2/FormInputPrice';
import FormInputAddressHouseCompleteManual from '../../../../common/formInputs/FormInputAddressHouseCompleteManual';
import FormInputAddressHouseComplete from '../../../../common/formInputs/FormInputAddressHouseComplete';
import { FormLayout } from '../../../../common/formInputsV2/FormLayout.styles';

function DatiUbicazioneStep({
  register,
  errors,
  isValid,
  formDataFlow,
  updateFormData,
  municipalities,
  setValue,
}) {
  const [showManualAdressHouse, setShowManualAdressHouse] = useState(false);

  useEffect(() => {
    if (formDataFlow.interested_in_building_fire_coverage === '0') {
      setValue('building_value', null, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }

    if (formDataFlow.interested_in_contents_fire_coverage === '0') {
      setValue('insured_amount_contents_fire', null, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }
  }, [formDataFlow.interested_in_building_fire_coverage, formDataFlow.interested_in_contents_fire_coverage]);

  return (
    <FormLayout>
      <FormInputSelect
        label="Tipo di abitazione"
        registration={register('house_type')}
        error={errors.house_type?.message}
        valid={isValid('house_type')}
        placeholder="-Seleziona-"
        options={houseTypes}
      />

      <FormInputSelect
        disabled={!formDataFlow.house_type}
        label="Tipologia abitativa"
        registration={register('housing_type')}
        error={errors.housing_type?.message}
        valid={isValid('housing_type')}
        placeholder="-Seleziona-"
        options={formDataFlow.house_type === '1' ? housing_types : apartament_types}
      />

      {formDataFlow.house_type && formDataFlow.house_type == '2' && (
        <>
          <FormInputRadio
            options={flagResponse}
            label="Presenza di polizza condominiale"
            name="presence_of_condominium_policy"
            registration={register('presence_of_condominium_policy')}
            error={errors.presence_of_condominium_policy?.message}
          />
        </>
      )}

      <FormInputSelect
        label="Uso abitazione"
        registration={register('residential_use_types')}
        error={errors.residential_use_types?.message}
        valid={isValid('residential_use_types')}
        placeholder="-Seleziona-"
        options={residential_use_types}
      />

      {formDataFlow.housing_type && formDataFlow.housing_type !== '117' && (
        <FormInputText
          placeholder="Livello del piano"
          label="Livello del piano"
          registration={register('floor_level')}
          error={errors.floor_level?.message}
          valid={isValid('floor_level')}
          type="number"
        />
      )}

      <FormInputSelect
        label="Caratteristica costruttiva"
        registration={register('construction_feature_types')}
        error={errors.construction_feature_types?.message}
        valid={isValid('construction_feature_types')}
        placeholder="-Seleziona-"
        options={construction_feature_types}
      />
      <FormInputSelect
        label="Anno di costruzione dell'immobile"
        registration={register('construction_year')}
        error={errors.construction_year?.message}
        valid={isValid('construction_year')}
        placeholder="-Seleziona-"
        options={formDataFlow.construction_feature_types === '162' ? construction_year.filter((el) => el.id !== 'fino_al_1960') : construction_year}
      />

      {!['145', '146'].includes(formDataFlow.residential_use_types)
        && (
          <>
            <FormInputRadio
              options={flagResponse}
              label="Sei interessato alla copertura incendio fabbricato?"
              name="interested_in_building_fire_coverage"
              registration={register('interested_in_building_fire_coverage')}
              error={errors.interested_in_building_fire_coverage?.message}
            // disabled={['144'].includes(formDataFlow.residential_use_types)}
            />

          </>
        )}

      {formDataFlow.interested_in_building_fire_coverage === '1'
        && (
          <FormInputPrice
            label="Valore Fabbricato"
            placeholder="Valore Fabbricato"
            value={formDataFlow.building_value}
            name="building_value"
            valid={isValid('building_value')}
            onChange={(value) => setValue('building_value', value, {
              shouldValidate: true,
              shouldDirty: true,
              shouldTouch: true,
            })}
            error={errors.building_value?.message}
          />
        )}

      <FormInputRadio
        options={flagResponse}
        label="Sei interessato alla copertura incendio contenuto?"
        name="interested_in_contents_fire_coverage"
        registration={register('interested_in_contents_fire_coverage')}
        error={errors.interested_in_contents_fire_coverage?.message}
        disabled={['145', '146'].includes(formDataFlow.residential_use_types)}
      />

      {formDataFlow.interested_in_contents_fire_coverage === '1' && (
        <FormInputPrice
          label="Valore Contenuto"
          placeholder="Valore Contenuto"
          value={formDataFlow.insured_amount_contents_fire}
          valid={isValid('insured_amount_contents_fire')}
          name="insured_amount_contents_fire"
          onChange={(value) => setValue('insured_amount_contents_fire', value, {
            shouldValidate: true,
            shouldDirty: true,
            shouldTouch: true,
          })}
          error={errors.insured_amount_contents_fire?.message}
        />
      )}

      <FormInputSelect
        label="Sei Propietario?"
        registration={register('owner_typology')}
        error={errors.owner_typology?.message}
        valid={isValid('owner_typology')}
        placeholder="-Seleziona-"
        options={ownerTypes}
      />

      <FormInputText
        placeholder="Superficie abitazione"
        label="Superficie abitazione"
        registration={register('square_meters')}
        error={errors.square_meters?.message}
        valid={isValid('square_meters')}
      />

      {showManualAdressHouse ? (
        <FormInputAddressHouseCompleteManual
          municipalities={municipalities}
          formData={formDataFlow}
          isValid={isValid}
          errors={errors}
          register={register}
          updateFormData={updateFormData}
        />
      ) : (
        <FormInputAddressHouseComplete
          municipalities={municipalities}
          formData={formDataFlow}
          isValid={isValid}
          errors={errors}
          register={register}
          updateFormData={updateFormData}
          addressId="autocomplete-address-house"
          setShow={setShowManualAdressHouse}
        />
      )}
    </FormLayout>
  );
}

export default DatiUbicazioneStep;
